<template>
  <div class="mainChild page-content" id="mainChild">
    <div>
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item>智慧服务</el-breadcrumb-item>
        <el-breadcrumb-item>关键词搜索</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div v-show="divShow">
      <div class="carlss" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="divLoading">
        加载中
      </div>
    </div>

    <section style="padding: 20px;margin-bottom: 10px;background-color: white;">
      <div class="title f16" style="font-size: 20px;font-weight: 600;margin: 16px 0 16px 0;">
        <span v-for="(item, i) in newPlateList" :key="i" :class="activeKey == item.dictCode ? 'active' : ''"
          @click="navChange(item)">{{ item.dictName }}</span>
      </div>
      <section class="seaerch-wrapper" style="padding: 0px;margin: 0px;">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="商品标题" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入" v-model="list.itemtitle" size="small"></el-input>
          </el-form-item>
          <el-form-item label="店铺名称" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入" v-model="list.shopname" size="small"></el-input>
          </el-form-item>
          <el-form-item label="关键词" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入" v-model="list.keyword" size="small"></el-input>
          </el-form-item>
          <el-form-item></el-form-item>
          <el-form-item></el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="getIprPluginListList(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </section>

    <section class="content-warpper">
      <div class="headerBrand">
        <div class="searchContainer">
          <div class="downBtn">
            <el-button @click="downTable" size="small" :loading="downTableTrue" type="primary"
              :disabled="disbutton">下载数据</el-button>
            <el-button @click="delBatches" size="small" :disabled="disbutton">批量删除</el-button>
            <el-button @click="marking('关键词设置')" size="small" :disabled="disbutton">关键词设置</el-button>
            <el-button @click="marking('筛选品牌')" size="small" :disabled="disbutton">筛选品牌</el-button>
            <el-button @click="marking('筛选品牌日志')" size="small" :disabled="disbutton">筛选品牌日志</el-button>
          </div>
        </div>
      </div>

      <tableHeader :selectAll='selectAll' :headerShow="true" :brandStore="true" :batchDisable="batchDisable"
        :chekTableNum="chekTableNum" @allCheck="toggleSelection(tableList, 'true')" @cancelAllCheck="toggleSelection()">
      </tableHeader>

      <div class="downContainer">
        <el-table ref="multipleTable" :data="tableList" tooltip-effect="dark" style="width: 100%"
          @selection-change="selectionChange" v-loading="dataLoading" element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading">
          <el-table-column type="selection" width="30" fixed="left"></el-table-column>
          <el-table-column label="序号" align="left" type="index" width="65" fixed="left">
            <template slot-scope="scope">
              {{ scope.$index | indexMethod(list.pageNo, list.pageSize) }}
            </template>
          </el-table-column>

          <el-table-column label="商品信息" prop="itemtitle" width="480">
            <template slot-scope="scope" class="shopInfo">
              <div class="shopMain">
                <el-image :src="scope.row.logopicurl_details ? scope.row.logopicurl_details : scope.row.logopicurl"
                  style="height: 84px;width: 84px;margin-right: 12px;"></el-image>
                <div class="content">
                  <el-link class="align_left two_ellipsis" :underline="false" :href="scope.row.itemlink" type="primary"
                    target="_blank">
                    {{ scope.row.itemtitle_details ? scope.row.itemtitle_details : scope.row.itemtitle }}
                  </el-link>
                  <el-button type="primary" size="mini" plain
                    @click="skuListChildShow(scope.row.itemid, scope.row.platform)" v-show="scope.row.itemtype == 2">
                    SKU列表
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="name" label="价格" width="200">
            <template slot-scope="scope">
              <div style="float: left;width: 100%;">
                <div v-if="scope.row.price" style="float: left;">
                  标价：¥{{ scope.row.price }}
                </div>
                <div v-if="scope.row.islowprice" class="islowpriceStyle"
                  style="width: 39px;float: right;margin: 3px 10px;">标低</div>
              </div>
              <div style="float: left;;width: 100%;">
                <div v-if="scope.row.availableprice" style="float: left;">
                  到手价：¥{{ scope.row.availableprice }}
                </div>
                <div v-if="scope.row.availableislowprice" style="width: 51px;float: right;margin: 3px 10px;"
                  class="availableislowpriceStyle">
                  到手低
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="店铺/经销商" show-overflow-tooltip width="250">
            <template slot-scope="scope">
              <div v-if="scope.row.shopname" class="align_left ellipsis">{{ scope.row.shopname }}</div>
              <div v-else class="align_left ellipsis">/</div>
              <div v-show="scope.row.wangwang && dictCodeShow == 'TBTM' || dictCodeShow == '1688'"
                class="align_left ellipsis">{{ scope.row.wangwang }}</div>
              <div class="tall_icon">
                <img :src='require("@/assets/img/platform/pla_" + scope.row.platform + ".png")' alt class="edit_icon" />
                <span style="margin-top: 8px;" class="shoptype green" v-show="scope.row.authorize">{{
                  scope.row.authorize }}</span>
                <ShopType style="margin-top: 8px;" :shoptype="scope.row.shoptype" v-if="scope.row.shoptype" />
              </div>
              <div class="align_left ellipsis">{{ scope.row.dealername }}</div>
            </template>
          </el-table-column>
          <el-table-column label="月销量" prop="salevolume" width="100"></el-table-column>
          <el-table-column label="累计评价" prop="evaluate_num"></el-table-column>
          <el-table-column prop="area" label="发货地" width="150"></el-table-column>
        </el-table>

        <pagination v-if="tableList && tableList.length > 0" :currentPage="paginae.currentPage"
          :pageSizes="paginae.pageSizes" :total="paginae.total" @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </section>

    <!--关键词设置弹窗-->
    <el-dialog :title="dialogName" :visible.sync="markingShow" width="360px" height="278" size="small">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="关键词：" label-width="120px" required>
          <el-input :clearable="true" placeholder="请输入关键词" v-model="paChongPageWard" size="small"></el-input>
        </el-form-item>
        <el-form-item label="页码：" label-width="120px" required v-if="dialogName == '关键词设置'">
          <el-input :clearable="true" placeholder="开始页码" v-model="start" type="number" size="small"
            style="width: 80px;"></el-input>
          —
          <el-input :clearable="true" placeholder="结束页码" v-model="end" type="number" size="small"
            style="width: 80px;"></el-input>
        </el-form-item>
        <el-form-item label="cookie：" label-width="120px" required v-else>
          <el-input :clearable="true" placeholder="请输入cookie" v-model="cookie" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="keyword_search" v-loading="keyLoading">确 定</el-button>
        <el-button @click="markingShow = false" size="small" type="cancel_blue">取 消</el-button>
      </span>
    </el-dialog>

    <!--筛选品牌日志-->
    <el-dialog title="筛选品牌日志" :visible.sync="pinPaiShow" size="small">
      <section class="seaerch-wrapper" style="padding: 10px 0px 10px 0px;margin: 0px;">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="关键词" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入" v-model="list2.keyword" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="findPageKeywordBrandLog()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
      <el-table :data="tableData" style="width: 100%">
        
        <el-table-column prop="keyword" label="关键词" width="180">
        </el-table-column>
        <el-table-column prop="progress" label="日志">
        </el-table-column>
        <el-table-column label="日期">
            <template slot-scope="scope" v-if="scope.row.createtime">
              {{ scope.row.createtime | fullTime }}
            </template>
          </el-table-column>
      </el-table>
      <pagination v-if="tableData && tableData.length > 0" :currentPage="pageChild.currentPage"
        :pageSizes="pageChild.pageSizes" :total="pageChild.total" @handleSizeChange="handleSizeChange2"
        @handleCurrentChange="handleCurrentChange2">
      </pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="pinPaiShow = false">确 定</el-button>
        <el-button @click="pinPaiShow = false" size="small" type="cancel_blue">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 批量删除提示-->
    <elementHint ref="hintCommon" :main="hint.main" @hintConfire="hintConfire" @hintShowCancel="hintShowCancel">
    </elementHint>

    <skuList ref="skuListChild" :dictCodeShow="dictCodeShow"></skuList>
  </div>
</template>

<script>
import pagination from "@/components/dataTable/pagination";
import elementHint from "@/components/dataTable/elementHint";
import tableHeader from "../CreditScore/common/tableHeader";
import ShopType from "@/components/shopType";
import skuList from "../Brand/BrandMerchandise/skuList";

export default {
  name: "brandStore",
  data() {
    return {
      tableData: [],
      pinPaiShow: false,
      keyLoading: false,
      // 关键词设置
      start: 1,
      end: 5,
      paChongPageWard: '',
      markingShow: false,

      // 平台列表
      newPlateList: [
        { dictCode: "TB", dictName: "淘宝天猫" },
        { dictCode: "JD", dictName: "京东商城" }
      ],

      // 当前平台
      activeKey: "TB",
      dictCodeShow: "TB",

      // 加载状态
      divLoading: true,
      divShow: false,
      dataLoading: false,
      downTableTrue: false,

      // 表格数据
      tableList: [],

      // 查询参数
      list: {
        pageNo: 1,
        pageSize: 10,
        platform: "TB",
        itemtitle: "",
        shopname: "",
        keyword: ""
      },

      // 查询参数
      list2: {
        pageNo: 1,
        pageSize: 10,
        keyword: "",
      },

      // 分页配置
      paginae: {
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
        total: 0
      },

      pageChild: {
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
        total: 0
      },

      // 批量操作
      disbutton: true,
      batchDisable: true,
      selectAll: false,
      chekTableNum: {
        all: 0,
        check: 0
      },
      delInfo: {
        checkAll: false,
        info: []
      },

      // 表单宽度
      formLabelWidth: "100px",

      // 提示框
      hint: { main: "你确认将该商品移出商品库吗？" },
      bmcid: '',
      dialogName: '',
      cookie: '',
    };
  },
  mounted() {
    this.selectAll = true
    this.bmcid = localStorage.getItem('bmcKefuid'),
      this.getIprPluginListList();
  },
  methods: {
    // 关键词搜索
    keyword_search() {
      if (!this.paChongPageWard) {
        this.$message.warning("请输入关键词");
        return;
      }
      let datas = {}
      let url = ''
      if (this.dialogName == '关键词设置') {
        if (Number(this.start) > Number(this.end)) {
          this.$message.warning("开始页码不能大于结束页码");
          return;
        }
        datas = {
          platform: this.list.platform,
          Keyword: this.paChongPageWard,
          end: this.end,
          start: this.start,
          bmcid: this.bmcid
        };
        url = "hcm/wechat/iprKeywordSearchBySpider"
      } else {
        if (!this.cookie) {
          this.$message.warning("请输入cookie值");
          return;
        }
        datas = {
          Keyword: this.paChongPageWard,
          cookie: this.cookie
        };
        url = "hcm/wechat/getBrandByTitle"
      }
      this.keyLoading = true;
      fetch({
        url: url,
        method: "post",
        data: datas,
        timeout: 60 * 1000 * 5
      }).then(res => {
        if (res.status == '10000') {
          this.keyLoading = false;
          this.$message.success('设置成功');
          this.markingShow = false;
          this.getIprPluginListList();
        } else {
          this.keyLoading = false;
          this.$message.warning(res.message);
        }
      }).catch(() => {
        this.$message.error('请求失败');
      });
    },

    // 打开关键词设置弹窗
    marking(name) {
      if (name == '筛选品牌日志') {
        this.list2.pageNo = 1;
        this.list2.pageSize = 10;
        this.findPageKeywordBrandLog();

      } else {
        this.dialogName = name;
        this.paChongPageWard = '';
        this.cookie = '';
        this.start = 1;
        this.end = 5;
        this.getIprPluginListList();
        this.markingShow = true;
      }

    },

    // 显示SKU列表
    skuListChildShow(id, platform) {
      let skuData = {
        itemid: id,
        platform: platform,
        pageNo: 1,
        pageSize: 10000,
        itemtype: 2,
      };
      this.$refs.skuListChild.dialogVisibleShow();
      this.$refs.skuListChild.getSkuList(skuData);
    },

    // 批量删除
    delBatches() {
      if (this.delInfo.info.length == 0) {
        this.$message.warning("没有选择任何信息");
        return false;
      }
      this.$refs.hintCommon.ifsee();
    },

    // 确认删除
    hintConfire() {
      let deleteIds = this.delInfo.info.map(item => item.id).join(',');
      let data = {
        ids: deleteIds
      }
      if (this.list.platform) {
        data.platform = this.list.platform;
      }
      if (this.list.itemtitle) {
        data.itemtitle = this.list.itemtitle;
      }
      if (this.list.shopname) {
        data.shopname = this.list.shopname;
      }
      if (this.list.keyword) {
        data.keyword = this.list.keyword;
      }
      
      if (this.delInfo.checkAll) {
        //全部删除
        data.ids = "checkAll";
      } else {
        let arr = [];
        for (let item of this.delInfo.info) {
          arr.push(item.id);
        }
        data.ids = arr.join(",");
      }
      fetch({
        url: "hcm/iprKeywordSearch/iprKeywordSearchdelete",
        method: "post",
        data: data,
        timeout: 60 * 1000 * 5
      }).then(res => {
        if (res.status == "10000") {
          this.getIprPluginListList();
          this.$refs.hintCommon.closeifsee();
          this.$message.success("删除成功!");
        } else {
          this.$message.warning("删除失败");
          this.$refs.hintCommon.closeifsee();
        }
      }).catch(() => {
        this.$message.error("删除失败");
        this.$refs.hintCommon.closeifsee();
      });
    },

    // 取消提示框
    hintShowCancel() {
      this.$refs.hintCommon.closeifsee();
    },

    // 表格选择变化
    selectionChange(data) {
      this.delInfo.info = data;
      this.chekTableNum.check = data.length;

      if (data.length === this.tableList.length && this.tableList.length > 0) {
        this.delInfo.checkAll = true;
      } else {
        this.delInfo.checkAll = false;
      }

      this.batchDisable = data.length === 0;
    },

    // 全选/取消全选
    // toggleSelection(rows, all) {
    //   if (all) {
    //     // 全选
    //     rows.forEach(row => {
    //       this.$refs.multipleTable.toggleRowSelection(row, true);
    //     });
    //     this.batchDisable = false;
    //     this.delInfo.checkAll = true;
    //     this.chekTableNum.check = this.paginae.total;
    //   } else {
    //     // 取消全选
    //     this.$refs.multipleTable.clearSelection();
    //     this.batchDisable = true;
    //     this.delInfo.checkAll = false;
    //     this.chekTableNum.check = 0;
    //   }
    // },
    toggleSelection(rows, all) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      } else {
        //不是勾选全部
        this.$refs.multipleTable.clearSelection();
        this.$set(this, "batchDisable", true);
        this.delInfo.checkAll = false;
        this.$set(this.chekTableNum, "check", 0);
      }
      if (all) {
        //勾选全部
        this.$set(this.chekTableNum, "check", this.paginae.total);
        this.$set(this, "batchDisable", false);
        this.delInfo.checkAll = true;
      }
    },

    // 获取商品列表
    getIprPluginListList(e) {
      this.dataLoading = true;

      if (e == 1) {
        this.paginae.currentPage = 1;
        this.list.pageNo = 1;
      }

      let params = {
        pageNo: this.list.pageNo,
        pageSize: this.list.pageSize,
        platform: this.list.platform
      };
      // if (this.list.platform == 'TB') {
      //   params.platform = 'TBTM';
      // } else {
      //   params.platform = this.list.platform;
      // }
      if (this.list.itemtitle) {
        params.itemtitle = this.list.itemtitle;
      }
      if (this.list.shopname) {
        params.shopname = this.list.shopname;
      }
      if (this.list.keyword) {
        params.keyword = this.list.keyword;
      }
      fetch({
        url: "hcm/iprKeywordSearch/findPageIprKeywordSearch",
        method: "post",
        data: params,
        timeout: 60 * 1000 * 5
      }).then(res => {
        if (res.status == "10000") {
          this.cookie = res.data.obj;
          this.disbutton = false;
          this.tableList = res.data.content || [];
          this.paginae.total = res.data.totalElements || 0;
          this.chekTableNum.all = res.data.totalElements || 0;
        } else {
          this.tableList = [];
          this.paginae.total = 0;
          this.chekTableNum.all = 0;
        }
        this.dataLoading = false;
        this.paginae.currentPage = this.list.pageNo;
      }).catch(() => {
        this.tableList = [];
        this.paginae.total = 0;
        this.chekTableNum.all = 0;
        this.dataLoading = false;
      });
    },
    // 分页大小变化
    handleSizeChange2(val) {
      this.list2.pageSize = val;
      this.findPageKeywordBrandLog();
    },

    // 当前页变化
    handleCurrentChange2(val) {
      this.list2.pageNo = val;
      this.findPageKeywordBrandLog();
    },
    // 品牌筛选日志
    findPageKeywordBrandLog() {
      let params = {
        pageNo: this.list2.pageNo,
        pageSize: this.list2.pageSize,
      };
      if (this.list2.keyword) {
        params.keyword = this.list2.keyword
      }
      fetch({
        url: "hcm/iprKeywordBrandLog/findPageKeywordBrandLog",
        method: "post",
        data: params,
        timeout: 60 * 1000 * 5
      }).then(res => {
        if (res.status == "10000") {
          this.pinPaiShow = true;
          this.tableData = res.data.content || [];
          this.pageChild.total = res.data.totalElements || 0;
        } else {
          this.tableData = [];
          this.pageChild.total = 0;
        }
        this.pageChild.currentPage = this.list2.pageNo;
      }).catch(() => {
        this.tableData = [];
        this.pageChild.total = 0;
      });
    },

    // 平台切换
    navChange(item) {
      this.dictCodeShow = item.dictCode;
      this.activeKey = item.dictCode;
      this.list.platform = item.dictCode;

      this.list.pageNo = 1;
      this.list.pageSize = 10;
      this.paginae.currentPage = 1;

      this.getIprPluginListList();
    },

    // 分页大小变化
    handleSizeChange(val) {
      this.list.pageSize = val;
      this.getIprPluginListList();
    },

    // 当前页变化
    handleCurrentChange(val) {
      this.list.pageNo = val;
      this.getIprPluginListList();
    },

    // 下载表格数据
    downTable() {
      this.downTableTrue = true;

      let params = {
        pageNo: this.list.pageNo,
        pageSize: this.list.pageSize,
        platform: this.list.platform
      };

      if (this.list.itemtitle) {
        params.itemtitle = this.list.itemtitle;
      }
      if (this.list.shopname) {
        params.shopname = this.list.shopname;
      }
      if (this.list.keyword) {
        params.keyword = this.list.keyword;
      }
      fetch({
        url: "hcm/iprKeywordSearch/iprKeywordSearchDownload",
        method: "post",
        data: params,
        responseType: "blob"
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "品牌商品库.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.downTableTrue = false;
      }).catch(() => {
        this.downTableTrue = false;
        this.$message.error("下载失败");
      });
    }
  },
  components: {
    pagination,
    elementHint,
    tableHeader,
    ShopType,
    skuList
  },
  filters: {
    indexMethod(index, pageNo, pageSize) {
      return (pageNo - 1) * pageSize + index + 1;
    }
  }
};
</script>

<style scoped lang="scss">
$colorBlur: #409eff;

.mainChild {
  .ellipsis {
    width: 100%;
  }

  .el-button--primary.is-plain {
    margin-top: 5px;
  }

  .downContainer {
    margin-top: 5px;
  }

  .skuList {
    color: $colorBlur;
    cursor: pointer;
  }

  .two_ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 2em;
    max-height: 50px;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    font-weight: 600;
  }

  .content-warpper {
    min-height: 766px;
  }

  .headerBrand {
    position: relative;
  }

  .dangerTag {
    color: #e90e24;
    font-size: 12px;
    border: 1px solid #e90e24;
    border-radius: 2px;
    padding: 0 3px;
    font-weight: bold;
    margin-right: 5px;
    margin-bottom: 5px;
    height: 17px;
    line-height: 17px;
  }

  .title {
    text-align: center;

    span {
      padding-left: 33px;
      cursor: pointer;
    }

    .span:hover,
    .active {
      color: #108cee;
    }
  }

  .searchContainer {
    .searchContainerMain {
      min-width: 500px;
      max-width: 612px;
      margin: auto;
      position: relative;
    }
  }

  .downBtn {
    display: flex;
    justify-content: flex-start;
  }

  .shopMain {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .content {
      width: calc(100% - 96px);
    }
  }

  .tall_icon {
    display: flex;
    align-items: center;

    img {
      margin-right: 9px;
    }

    .green {
      background: #52c41a;
    }
  }
}
</style>

<style lang="scss">
#mainChild {
  .el-table-column--selection .cell {
    text-align: center;
  }

  .el-link--inner {
    display: block;
    width: 100%;
  }

  .align_left {
    text-align: left;
  }

  .cell {
    text-align: left;
  }

  .el-table__empty-text {
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }

  .el-table th {
    background: #f3f7ff;
  }
}
</style>